// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { endpoints } from '../services/api';

export const AuthContext = createContext(null);


export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null); 

  const fetchUser = useCallback(async (authToken) => {
    if (!authToken) { setUser(null); return; }
    try {
      const res = await fetch(endpoints.auth.me, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (res.ok) {
        setUser(await res.json());
      } else if (res.status === 401) {
        setToken(null);
        setUser(null);
        localStorage.removeItem("nexaura_token");
      }
    } catch (_) {}

    try {
    const subRes = await fetch(endpoints.payments.status, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    if (subRes.ok) setSubscription(await subRes.json());
  } catch (_) {}
  }, []);

  useEffect(() => {
    const init = async (storedToken) => {
      setToken(storedToken);
      await fetchUser(storedToken);
      setLoading(false);
    };

    if (window.chrome && window.chrome.storage) {
      window.chrome.storage.local.get("nexaura_token", (result) => {
        const t = result.nexaura_token || localStorage.getItem("nexaura_token");
        init(t);
      });
    } else {
      init(localStorage.getItem("nexaura_token"));
    }
  }, [fetchUser]);

  const login = async (newToken) => {
    setToken(newToken);
    localStorage.setItem("nexaura_token", newToken);
    await fetchUser(newToken);
  };

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    setSubscription(null);
    localStorage.removeItem("nexaura_token");
    window.postMessage({ type: "NEXAURA_LOGOUT" }, window.location.origin);
  }, []);

  useEffect(() => {
    const handleUnauthorized = () => {
      if (token) {
        logout();
      }
    };
    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
  }, [logout, token]);

  const refreshUser = useCallback(() => fetchUser(token), [fetchUser, token]);

  return (
    <AuthContext.Provider value={{ token, user, subscription, login, logout, loading, refreshUser }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
